import React from "react";

import CustomAttributesSection from "shared/Applicant/LinkWithUniversity/components/CustomAttributesSection";

import {useUniversity} from "../../../UniversityProvider/UniversityProvider";

export function CustomAttributesFormFields() {
    const {features, customAttributes} = useUniversity();

    const customAttributesEnabled = features.get("customProspectSignupAttributes");

    if (!customAttributesEnabled) return null;

    return <CustomAttributesSection attributes={customAttributes} />;
}
